const normalizeEstadoInteres = (estado) =>
  String(estado || "")
    .trim()
    .toLowerCase();

export const getEstadoInteresBadgeClass = (estado) => {
  switch (normalizeEstadoInteres(estado)) {
    case "interesado":
      return "bg-primary-subtle text-primary";
    case "prematriculado":
    case "pre-matriculado":
      return "bg-warning-subtle text-warning";
    case "matriculado":
      return "bg-success-subtle text-success";
    case "descartado":
      return "bg-danger-subtle text-danger";
    default:
      return "bg-info-subtle text-info";
  }
};

export const getEstadoInteresLabel = (estado) => {
  switch (normalizeEstadoInteres(estado)) {
    case "interesado":
      return "Interesado";
    case "prematriculado":
    case "pre-matriculado":
      return "Pre-matriculado";
    case "matriculado":
      return "Matriculado";
    case "descartado":
      return "Descartado";
    default:
      return "Nuevo";
  }
};
